import {
	Directive,
	ElementRef,
	Input
}                          from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive( {
	selector: '[appDisableControl]'
} )
export class DisableControlDirective {

	private _control: AbstractControl;

	/*
	 * AbstractControl object is received from the form element component.
	 * Creation and employment of the directive's own NgControl instance was
	 * abandoned/removed due to timing problems with the creation of its
	 * associated AbstractControl object.
	 */
	@Input( 'appDisableControl' )
	set inputs( inputs: { condition: boolean, control: AbstractControl } ) {
		if ( !inputs?.control ) { return; }
		this._control = inputs.control;
		this.applyCondition( inputs.condition );
	}

	constructor(
		private el: ElementRef
	) {}

	applyCondition( condition: boolean ): void {

		if ( condition ) {
			this._control.disable();
			this.el.nativeElement.classList.add( 'disabled' );

		} else {
			this._control.enable();
			this.el.nativeElement.classList.remove( 'disabled' );
		}
	}
}
